import { render, staticRenderFns } from "./RH35.vue?vue&type=template&id=8845c772"
import script from "./RH35.vue?vue&type=script&lang=js"
export * from "./RH35.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports